// 组件对象，大写
import panguShrinkableMenu from './shrinkable-menu.vue'
export default panguShrinkableMenu
